import{k as t,l as n,o as c}from"./chunk-OZLKT3VR.js";import{e as r,m as o}from"./chunk-HBP5N4FR.js";import{createAction as i}from"@reduxjs/toolkit";var s,L,A=r(()=>{o();c();s=i(t),L=i(n,e=>({payload:e}))});export{s as a,L as b,A as c};
//# sourceMappingURL=chunk-PZH5XCLB.js.map
